import styled from '@emotion/styled';
import { FOCUS } from '../../constants';
import { IconButton } from 'react-magma-dom';

export const ToolButton = styled(IconButton)<{
  disabled?: boolean;
  margin?: string;
}>`
  background-color: white;
  ${({ margin }) => margin && `margin: ${margin};`}
  ${FOCUS}

  ${({ disabled }) => disabled && 'opacity: 0.2; pointer-events: none;'}
`;

export const StyledImageBorder = styled.div<{
  editMode: boolean;
  isVisible: boolean;
  showBorder?: boolean;
  hasPosition: boolean;
}>`
  ${FOCUS}
  width: fit-content;
  display: flex;
  justify-content: flex-end;
  height: ${({ hasPosition }) => (hasPosition ? '100%' : 'auto')};
  border: ${({ editMode, showBorder }) => {
    if (showBorder) {
      return editMode ? 'dashed 1px #000000' : 'dashed 1px transparent';
    }

    return editMode ? 'dashed 1px #000000' : 'none';
  }};
  cursor: ${({ editMode }) => (editMode ? 'pointer' : '')};
  background: ${({ isVisible }) => (isVisible ? '' : '#f2f2f2')};
  z-index: -1;
  margin: ${({ showBorder }) => (showBorder ? '0 0 5px 0' : '0')};
`;

export const StyledImageFlexWrapper = styled.div<{ hasPosition: boolean }>`
  width: fit-content;
  display: flex;
  justify-content: flex-end;
  position: relative;
  height: ${({ hasPosition }) => (hasPosition ? '100%' : 'auto')};
`;

export const StyledTool = styled.div`
  background-color: white;
  position: absolute !important;
  right: 20px;
  top: 20px;
  display: flex;
  flex-direction: column;
  box-shadow: 4px 4px 4px 0 rgb(0 0 0 / 15%);
  z-index: 100;
`;

export const StyledImage = styled.img<{
  height?: number;
  width?: number;
  borderRadius?: string;
  isVisible?: boolean;
}>`
  width: ${({ width }) => (width ? `${width}%` : 'auto')};
  height: ${({ height }) => (height ? `${height}%` : 'auto')};

  ${({ borderRadius }) => borderRadius && `border-radius: ${borderRadius};`}

  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};

  cursor: pointer;
  object-fit: contain;
`;

export const StyledIntroductionToHybridImage = styled.div`
  width: 131px;
  margin: 104px 73px 0px 61px;
`;
